import { Employee, Candidate, Interview } from '../types/hr.types'

// Helper to generate dates relative to today
const today = new Date()
const tomorrow = new Date(today)
tomorrow.setDate(today.getDate() + 1)
const yesterday = new Date(today)
yesterday.setDate(today.getDate() - 1)
const nextDay = new Date(today)
nextDay.setDate(today.getDate() + 2)
const nextWeek = new Date(today)
nextWeek.setDate(today.getDate() + 7)
const nextMonth = new Date(today)
nextMonth.setDate(today.getDate() + 15)

const formatDate = (d: Date) => d.toISOString().split('T')[0]
const formatMMDD = (d: Date) =>
  `${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

export const mockEmployees: Employee[] = [
  {
    id: 'e1',
    name: 'Sarah Jenkins',
    department: 'Engineering',
    photoUrl:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    birthday: formatMMDD(today), // Birthday today
    isActive: true,
  },
  {
    id: 'e2',
    name: 'Michael Chen',
    department: 'Product',
    photoUrl:
      'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    birthday: formatMMDD(tomorrow), // Birthday tomorrow
    isActive: true,
  },
  {
    id: 'e3',
    name: 'Emily Davis',
    department: 'Marketing',
    photoUrl:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    birthday: formatMMDD(nextDay), // Birthday this week
    isActive: true,
  },
  {
    id: 'e4',
    name: 'David Wilson',
    department: 'Sales',
    photoUrl:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    birthday: '05-15', // Random date
    isActive: true,
  },
  {
    id: 'e5',
    name: 'Jessica Taylor',
    department: 'HR',
    photoUrl:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    birthday: formatMMDD(today), // Another birthday today
    isActive: true,
  },
]

export const mockCandidates: Candidate[] = [
  {
    id: 'c1',
    firstName: 'Alex',
    lastName: 'Johnson',
    role: 'Team Lead',
    department: 'Operations',
    phoneInterviewDate: formatDate(today),
    email: 'alex.j@example.com',
    phone: '(555) 123-4567',
    status: 'Ready to Start',
    branch: 'Troy',
    interviewedBy: 'Kaylin Stepho',
    candidateSource: 'LinkedIn',
  },
  {
    id: 'c2',
    firstName: 'Maria',
    lastName: 'Rodriguez',
    role: 'Loan Officer',
    department: 'Sales',
    phoneInterviewDate: formatDate(tomorrow),
    email: 'maria.r@example.com',
    phone: '(555) 987-6543',
    status: 'Pre-boarding',
    branch: 'Arizona',
    interviewedBy: 'Zeinab Haidar',
    candidateSource: 'Indeed',
  },
  {
    id: 'c3',
    firstName: 'James',
    lastName: 'Smith',
    role: 'Loan Partner',
    department: 'Sales',
    phoneInterviewDate: formatDate(nextDay),
    email: 'james.s@example.com',
    phone: '(555) 456-7890',
    status: 'Offer Signed',
    branch: 'Miami',
    interviewedBy: 'Kaylin Stepho',
    candidateSource: 'Referral',
    referredBy: 'Sarah Johnson',
  },
  {
    id: 'c4',
    firstName: 'Emily',
    lastName: 'Chen',
    role: 'Processor',
    department: 'Operations',
    phoneInterviewDate: formatDate(today),
    email: 'emily.c@example.com',
    phone: '(555) 234-5678',
    status: 'Phone Screen',
    branch: 'Troy',
    interviewedBy: 'Zeinab Haidar',
    candidateSource: 'LinkedIn',
  },
  {
    id: 'c5',
    firstName: 'Michael',
    lastName: 'Brown',
    role: 'Telemarketer',
    department: 'Sales',
    phoneInterviewDate: formatDate(nextWeek),
    email: 'michael.b@example.com',
    phone: '(555) 876-5432',
    status: 'Offer Signed',
    branch: 'Arizona',
    interviewedBy: 'Kaylin Stepho',
    candidateSource: 'Indeed',
  },
  {
    id: 'c6',
    firstName: 'Sarah',
    lastName: 'Wilson',
    role: 'Admin',
    department: 'Operations',
    phoneInterviewDate: formatDate(nextMonth),
    email: 'sarah.w@example.com',
    phone: '(555) 345-6789',
    status: 'Pre-boarding',
    branch: 'Miami',
    interviewedBy: 'Zeinab Haidar',
    candidateSource: 'Referral',
    referredBy: 'Mike Williams',
  },
  {
    id: 'c7',
    firstName: 'David',
    lastName: 'Lee',
    role: 'Processing Manager',
    department: 'Operations',
    phoneInterviewDate: formatDate(today),
    email: 'david.l@example.com',
    phone: '(555) 432-1098',
    status: 'Phone Screen',
    branch: 'Miami',
    interviewedBy: 'Kaylin Stepho',
    candidateSource: 'LinkedIn',
  },
]

export const mockInterviews: Interview[] = [
  {
    id: 'i1',
    candidateName: 'Robert Brown',
    candidateId: 'c_pot_1',
    type: 'Phone Screen',
    dateTime: new Date(today.setHours(10, 0, 0, 0)).toISOString(), // Today 10am
    interviewer: 'Jessica Taylor',
    role: 'Customer Support Lead',
  },
  {
    id: 'i2',
    candidateName: 'Linda White',
    candidateId: 'c_pot_2',
    type: 'In-Person',
    dateTime: new Date(today.setHours(14, 30, 0, 0)).toISOString(), // Today 2:30pm
    interviewer: 'Sarah Jenkins',
    role: 'UX Designer',
  },
  {
    id: 'i3',
    candidateName: 'Thomas Anderson',
    candidateId: 'c_pot_3',
    type: 'Video Call',
    dateTime: new Date(tomorrow.setHours(11, 0, 0, 0)).toISOString(), // Tomorrow 11am
    interviewer: 'Michael Chen',
    role: 'Backend Engineer',
  },
  {
    id: 'i4',
    candidateName: 'Patricia Martin',
    candidateId: 'c_pot_4',
    type: 'Phone Screen',
    dateTime: new Date(nextDay.setHours(15, 0, 0, 0)).toISOString(), // Next day 3pm
    interviewer: 'Jessica Taylor',
    role: 'HR Coordinator',
  },
]
